import { useTranslation } from "react-i18next";
import { BellIcon, BellIconStrikeThrough } from "@components/icons";
import { Tooltip } from "@components/Tooltip/Tooltip";
import type { TReminderState } from "@services/customerStorage/types";

interface ICustomerStorageExpirationDateIconProps {
  reminderState: TReminderState;
}
export const CustomerStorageExpirationDateIcon: React.FC<
  ICustomerStorageExpirationDateIconProps
> = ({ reminderState }) => {
  const { t } = useTranslation();

  const ExpirationDateReminderIcon =
    reminderState === "active"
      ? BellIcon
      : reminderState === "expired"
        ? BellIconStrikeThrough
        : null;

  if (!ExpirationDateReminderIcon) {
    return null;
  }

  return (
    <Tooltip
      content={
        reminderState === "active"
          ? t("customerStorage.tooltip.reminderActive")
          : t("customerStorage.tooltip.reminderExpired")
      }
    >
      <ExpirationDateReminderIcon className="my-0.5 stroke-0 text-grey-dark" />
    </Tooltip>
  );
};
